import processEnv from "../processEnv";

const fetchOffersQuery = (oqry: any) => {
  console.log("PASSED QUERY DATA: ", oqry);
  const bodyP = {
    data: oqry,
  };
  console.warn("BODY P: ", bodyP);
  return fetch(`https://www.teksatravel.com:4040/api/search`, {
    method: "POST",
    referrerPolicy: "no-referrer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
      "Content-Type": "application/json",
      "Accept-Encoding": "gzip",
      Accept: "application/json",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
      "Duffel-Version": "v1",
      Authorization:
        "Bearer duffel_test_0D60g6XG_fY4RvLUMRtRQN5MaLzAGG2YnXuIWM9qu2p",
    },
    body: JSON.stringify(oqry),
  });
  /*
	return fetch(`https://api.duffel.com/air/partial_offer_requests`, {
		method: 'POST',
        referrerPolicy: 'no-referrer',
		headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
			'Content-Type': 'application/json',
             "Accept-Encoding":"gzip",
             "Accept": "application/json",
             "Access-Control-Allow-Methods":"GET,HEAD,OPTIONS,POST,PUT",
             "Duffel-Version": "v1" ,
            "Authorization": "Bearer duffel_test_0D60g6XG_fY4RvLUMRtRQN5MaLzAGG2YnXuIWM9qu2p",
		},
	   body: JSON.stringify(bodyP),
	})
	*/
};

export default fetchOffersQuery;
